// extracted by mini-css-extract-plugin
export default {"linkAdaptativo":"LinkAdaptativo_linkAdaptativo__6dOi2"};